export default __webpack_public_path__ + "static/media/0317.fa3d8d12.jpg";